import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { ToggleGroup } from "@base-ui/react/toggle-group";
import { Toggle } from "@base-ui/react/toggle";
import css from "./SegmentedButton.module.css";

const Item = React.forwardRef(
  ({ value, icon, disabled = false, className, children, ...rest }, ref) => (
    <Toggle
      ref={ref}
      value={value}
      disabled={disabled}
      className={clsx(css.item, className)}
      {...rest}
    >
      {icon && <span className={css.icon}>{icon}</span>}
      {children}
    </Toggle>
  ),
);

Item.displayName = "SegmentedButton.Item";

Item.propTypes = {
  value: PropTypes.string.isRequired,
  icon: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

const Group = React.forwardRef(
  (
    {
      value,
      defaultValue,
      onValueChange,
      multiple = false,
      disabled = false,
      className,
      children,
      ...rest
    },
    ref,
  ) => (
    <ToggleGroup
      ref={ref}
      value={value}
      defaultValue={defaultValue}
      onValueChange={onValueChange}
      multiple={multiple}
      disabled={disabled}
      className={clsx(css.group, className)}
      {...rest}
    >
      {children}
    </ToggleGroup>
  ),
);

Group.displayName = "SegmentedButton.Group";

Group.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  defaultValue: PropTypes.arrayOf(PropTypes.string),
  onValueChange: PropTypes.func,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

const SegmentedButton = { Group, Item };

export default SegmentedButton;
